import { z } from 'zod'
import type { Tags } from '@/types/pbSchema'

export type Tag = Tags

const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/

export const tagSchema = z.object({
    name: z
        .string()
        .min(3, 'Tag name must be at least 3 characters')
        .max(15, 'Tag name must be 15 characters or fewer')
        .regex(
            /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
            'Use lowercase letters, numbers, and hyphens only'
        ),
    color: z
        .string()
        .trim()
        .min(1, 'Color is required')
        .transform(value => (value.startsWith('#') ? value : `#${value}`))
        .refine(value => colorRegex.test(value), 'Enter a valid hex color (example: #3B82F6)'),
    description: z
        .string()
        .max(500, 'Description must be 500 characters or less')
        .optional(),
    inactive: z.boolean(),
})

export type TagFormData = z.infer<typeof tagSchema>

export interface DeleteTagDialogState {
    open: boolean
    tag: Tag | null
}

export interface EditTagDialogState {
    open: boolean
    tag: Tag | null
}
export type TagFormDataSchema = z.infer<typeof tagSchema>
